module.exports = [{
      plugin: require('../node_modules/@sentry/gatsby/gatsby-browser.js'),
      options: {"plugins":[],"dsn":"https://342f253e83984669a1e76bb77362345a@o464087.ingest.sentry.io/5471297","sampleRate":0.7},
    },{
      plugin: require('../node_modules/gatsby-plugin-canonical-urls/gatsby-browser.js'),
      options: {"plugins":[],"siteUrl":"https://www.glfonline.com.au"},
    },{
      plugin: require('../node_modules/gatsby-plugin-next-seo/gatsby-browser.js'),
      options: {"plugins":[],"openGraph":{"type":"website","locale":"en_AU","url":"https://www.glfonline.com.au/","site_name":"GLF"}},
    },{
      plugin: require('../node_modules/gatsby-plugin-google-gtag/gatsby-browser.js'),
      options: {"plugins":[],"trackingIds":["G-RLGCFH3LK8","UA-176704868-1","AW-596987398"]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"GLF Online","short_name":"GLF","start_url":"/","background_color":"#5850ec","theme_color":"#5850ec","display":"minimal-ui","icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"ff90bde37f2f0ba1000d6ab569808ced"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
